/**
 *
 * Darkened text that automatically highlights left to right
 * (example: Algo — Tech - scroll to "Algo transforms data into videos, at scale...." paragraph)
 *
 */

class AnimateHighlightText {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.initIntersectionObserver();
        this.animateText();
    }

    animateText() {
        const allDirectChildren = this.elem.querySelectorAll(':scope > *');

        allDirectChildren.forEach((directChild) => {
            if (directChild.tagName === 'P') {
                const directChildContent = directChild.innerHTML;
                directChild.innerHTML = this.wrapWords(directChildContent, '<span>$&</span>');
            }

            if (directChild.tagName === 'H2' || directChild.tagName === 'H1') {
                const directChildContent = directChild.innerHTML;
                directChild.innerHTML = this.wrapWords(directChildContent, '<span><span>$&</span></span>');
            }
        });
    }

    initIntersectionObserver() {
        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();

        const options = {
            root: null,
            threshold: 0.3,
            rootMargin: `${headerHeight * -1}px 0px 0px 0px`,
        };

        const animationObserver = new IntersectionObserver((entries, self) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                    self.unobserve(this.elem);
                } else {
                    entry.target.classList.remove('in-view');
                }
            });
        }, options);

        animationObserver.observe(this.elem);
    }

    /**
     * Wraps a string around each character/letter
     *
     * @param {string} str The string to transform
     * @param {string} tmpl Template that gets interpolated
     * @returns {string} The given input as splitted by chars/letters
     */
    wrapChars(str, tmpl) {
        str = str.replace(/./g, tmpl || '');
        return str.replace(/<span> <\/span>/g, tmpl || '<span>&nbsp;</span>');
    }

    /**
     * Wraps a string around each word
     *
     * @param {string} str The string to transform
     * @param {string} tmpl Template that gets interpolated
     * @returns {string} The given input splitted by words
     */
    wrapWords(str, tmpl) {
        str = str.replace(/[^ ]+/g, tmpl || '');
        // special lowercase rule for character inside tilde
        return str.replace(/~([a-zA-Z0-9\-\@:]+)~/g,'<span style="text-transform: lowercase;">$1</span>');
    }

    /**
     * Wraps a string around each line
     *
     * @param {string} str The string to transform
     * @param {string} tmpl Template that gets interpolated
     * @returns {string} The given input splitted by lines
     */
    wrapLines(str, tmpl) {
        return str.replace(/.+$/gm, tmpl || '<span><span>$&</span></span>');
    }
}

export default AnimateHighlightText;
